import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import React from "react";
import { Button } from "react-bootstrap";
import { FaFileExcel } from "react-icons/fa";
import { HiDownload } from "react-icons/hi";
import {
  formatTotalRow,
  getReport24Q_DeducteeDetailHeader,
  reportIncometaxMemoHeader,
  reportIncometaxMemo,
  isSeniorCitizen,
} from "./client/misc";

import {
  getAssessmentYear,
  calculateTaxFromJSON,
  calculateOldRegimeTax,
  getAgeCategoryFromDOB,
} from "./admin/misc";

const ExportToExcelDeductee24Q = ({
  data,
  fileName,
  formName,
  clientName = "",
  clientTan = "",
  financialYear = "",
  modelType,
}) => {
  const clientInfo = JSON.parse(localStorage.getItem("clientInfo"));

  const financialMonthOrder = [
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
    "Jan",
    "Feb",
    "Mar",
  ];

  const extractKeyValues = (arr, keyName) => {
    return arr.map((item) => item[keyName]);
  };

  const filterDataByKeys = (columns, data) => {
    console.log("Data", data);
    const allowedKeys = columns.map((col) => col.key);
    // console.log("allowkey", allowedKeys);

    return data.map((item) => {
      const filtered = {};
      allowedKeys.forEach((key) => {
        if (item.hasOwnProperty(key)) {
          filtered[key] = item[key];
        } else {
          filtered[key] = "";
        }
      });
      return filtered;
    });
  };

  const exportToExcel = async () => {
    const uniqueEmployee = data
      .filter(
        (item, index, self) =>
          index ===
          self.findIndex((obj) => obj.en === item.en && obj.pa === item.pa),
      )
      .map(({ en, pa, de }) => ({ en, pa, de }));

    const frmName = formName;
    const workbook = new ExcelJS.Workbook();

    let indexForEach = 0;
    uniqueEmployee.forEach(({ en, pa, de }) => {
      // console.log(en, pa, de);

      // const name = "testSheet";
      const name = `${en?.replace(/\s/g, "_")}_${pa}_${financialYear}`;

      const empData = data.filter((d) => d.en === en && d.pa === pa);
      const worksheet = workbook.addWorksheet(name);

      // let headerAndKeyArray = getReport24Q_DeducteeDetailHeader;
      let headerAndKeyArray = "";

      if (formName === "incometaxMemo") {
        headerAndKeyArray = reportIncometaxMemoHeader;
      } else if (formName === "deducteeDetail") {
        headerAndKeyArray = getReport24Q_DeducteeDetailHeader;
      }
      const headers = extractKeyValues(headerAndKeyArray, "label");

      if (formName === "deducteeDetail") {
        worksheet.mergeCells(1, 1, 1, 2);
        const OrgName = worksheet.getCell("A1");
        OrgName.value = "Organization Name";
        OrgName.font = { bold: true, size: 9 };
        OrgName.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FCD5B4" },
        };
        OrgName.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
        OrgName.alignment = { horizontal: "left", vertical: "middle" };
        worksheet.getRow(1).height = 25;

        worksheet.mergeCells(1, 3, 1, 20);
        const OrgNameValue = worksheet.getCell("C1");
        OrgNameValue.value = clientInfo?.client?.cn;
        OrgNameValue.font = { bold: true, size: 9 };
        OrgNameValue.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FCD5B4" },
        };
        OrgNameValue.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
        OrgNameValue.alignment = { horizontal: "left", vertical: "middle" };
        worksheet.getRow(1).height = 25;

        worksheet.mergeCells(2, 1, 2, 2);
        const OrgAdd = worksheet.getCell("A2");
        OrgAdd.value = "Organi. Add. with Pincode";
        OrgAdd.font = { bold: true, size: 9 };
        OrgAdd.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FCD5B4" },
        };
        OrgAdd.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
        OrgAdd.alignment = { horizontal: "left", vertical: "middle" };
        worksheet.getRow(1).height = 25;

        worksheet.mergeCells(2, 3, 2, 20);
        const OrgAddValue = worksheet.getCell("C2");
        OrgAddValue.value = `${clientInfo?.client?.a1} - ${clientInfo?.client?.pi}`;
        OrgAddValue.font = { bold: true, size: 9 };
        OrgAddValue.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FCD5B4" },
        };
        OrgAddValue.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
        OrgAddValue.alignment = { horizontal: "left", vertical: "middle" };
        worksheet.getRow(1).height = 25;

        worksheet.mergeCells(3, 1, 3, 2);
        const OrgDeductPan = worksheet.getCell("A3");
        OrgDeductPan.value = "Organi / Deductor - Pan";
        OrgDeductPan.font = { bold: true, size: 9 };
        OrgDeductPan.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FCD5B4" },
        };
        OrgDeductPan.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
        OrgDeductPan.alignment = { horizontal: "left", vertical: "middle" };
        worksheet.getRow(1).height = 25;

        worksheet.mergeCells(3, 3, 3, 4);
        const OrgDeductPanValue = worksheet.getCell("C3");
        OrgDeductPanValue.value = clientInfo?.client?.pa;
        OrgDeductPanValue.font = { bold: true, size: 9 };
        OrgDeductPanValue.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FCD5B4" },
        };
        OrgDeductPanValue.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
        OrgDeductPanValue.alignment = {
          horizontal: "left",
          vertical: "middle",
        };
        worksheet.getRow(1).height = 25;

        worksheet.mergeCells(3, 5, 3, 7);
        const OrgDeductTan = worksheet.getCell("E3");
        OrgDeductTan.value = "Organi. / Deductor - Tan";
        OrgDeductTan.font = { bold: true, size: 9 };
        OrgDeductTan.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FCD5B4" },
        };
        OrgDeductTan.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
        OrgDeductTan.alignment = { horizontal: "left", vertical: "middle" };
        worksheet.getRow(1).height = 25;

        worksheet.mergeCells(3, 8, 3, 20);
        const OrgDeductTanValue = worksheet.getCell("H3");
        OrgDeductTanValue.value = clientInfo?.client?.ta;
        OrgDeductTanValue.font = { bold: true, size: 9 };
        OrgDeductTanValue.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FCD5B4" },
        };
        OrgDeductTanValue.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
        OrgDeductTanValue.alignment = {
          horizontal: "left",
          vertical: "middle",
        };
        worksheet.getRow(1).height = 25;

        worksheet.mergeCells(4, 1, 4, 3);
        const EmployeeName = worksheet.getCell("A4");
        EmployeeName.value = "Employee Name";
        EmployeeName.font = { bold: true, size: 9 };
        EmployeeName.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FCD5B4" },
        };
        EmployeeName.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
        EmployeeName.alignment = { horizontal: "left", vertical: "middle" };
        worksheet.getRow(1).height = 25;

        worksheet.mergeCells(4, 4, 4, 8);
        const EmployeeNameValue = worksheet.getCell("D4");
        EmployeeNameValue.value = en;
        EmployeeNameValue.font = { bold: true, size: 9 };
        EmployeeNameValue.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FCD5B4" },
        };
        EmployeeNameValue.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
        EmployeeNameValue.alignment = {
          horizontal: "left",
          vertical: "middle",
        };
        worksheet.getRow(1).height = 25;

        // worksheet.mergeCells(4, 1, 4, 3);
        const EmployeeFY = worksheet.getCell("I4");
        EmployeeFY.value = "F.Y.";
        EmployeeFY.font = { bold: true, size: 9 };
        EmployeeFY.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FCD5B4" },
        };
        EmployeeFY.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
        EmployeeFY.alignment = { horizontal: "left", vertical: "middle" };
        worksheet.getRow(1).height = 25;

        worksheet.mergeCells(4, 10, 4, 20);
        const EmployeeFYValue = worksheet.getCell("J4");
        EmployeeFYValue.value = financialYear;
        EmployeeFYValue.font = { bold: true, size: 9 };
        EmployeeFYValue.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FCD5B4" },
        };
        EmployeeFYValue.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
        EmployeeFYValue.alignment = { horizontal: "left", vertical: "middle" };
        worksheet.getRow(1).height = 25;

        worksheet.mergeCells(5, 1, 5, 3);
        const EmployeePanNo = worksheet.getCell("A5");
        EmployeePanNo.value = "Employee Pan No.";
        EmployeePanNo.font = { bold: true, size: 9 };
        EmployeePanNo.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FCD5B4" },
        };
        EmployeePanNo.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
        EmployeePanNo.alignment = { horizontal: "left", vertical: "middle" };
        worksheet.getRow(1).height = 25;

        worksheet.mergeCells(5, 4, 5, 8);
        const EmployeePanNoValue = worksheet.getCell("D5");
        EmployeePanNoValue.value = pa;
        EmployeePanNoValue.font = { bold: true, size: 9 };
        EmployeePanNoValue.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FCD5B4" },
        };
        EmployeePanNoValue.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
        EmployeePanNoValue.alignment = {
          horizontal: "left",
          vertical: "middle",
        };
        worksheet.getRow(1).height = 25;

        // worksheet.mergeCells(4, 1, 4, 3);
        const EmployeeDesignation = worksheet.getCell("I5");
        EmployeeDesignation.value = "Designation";
        EmployeeDesignation.font = { bold: true, size: 9 };
        EmployeeDesignation.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FCD5B4" },
        };
        EmployeeDesignation.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
        EmployeeDesignation.alignment = {
          horizontal: "left",
          vertical: "middle",
        };
        worksheet.getRow(1).height = 25;

        worksheet.mergeCells(5, 10, 5, 20);
        const EmployeeDesignationValue = worksheet.getCell("J5");
        EmployeeDesignationValue.value = de;
        EmployeeDesignationValue.font = { bold: true, size: 9 };
        EmployeeDesignationValue.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FCD5B4" },
        };
        EmployeeDesignationValue.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
        EmployeeDesignationValue.alignment = {
          horizontal: "left",
          vertical: "middle",
        };
        worksheet.getRow(1).height = 25;

        worksheet.mergeCells(6, 1, 6, 3);
        const AuthPersonName = worksheet.getCell("A6");
        AuthPersonName.value = "Mob. No.";
        AuthPersonName.font = { bold: true, size: 9 };
        AuthPersonName.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FCD5B4" },
        };
        AuthPersonName.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
        AuthPersonName.alignment = { horizontal: "left", vertical: "middle" };
        worksheet.getRow(1).height = 25;

        worksheet.mergeCells(6, 4, 6, 20);
        const AuthPersonNameValue = worksheet.getCell("D6");
        AuthPersonNameValue.value = clientInfo?.client?.ap;
        AuthPersonNameValue.font = { bold: true, size: 9 };
        AuthPersonNameValue.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FCD5B4" },
        };
        AuthPersonNameValue.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
        AuthPersonNameValue.alignment = {
          horizontal: "left",
          vertical: "middle",
        };
        worksheet.getRow(1).height = 25;

        // ✅ 2. Manually add header row (row 2)
        const headerRow = worksheet.getRow(7);
        headers.forEach((header, index) => {
          if (header == "dc" || header == "ar" || header == "bo") return;
          const cell = headerRow.getCell(index + 1);
          cell.value = header;
          cell.font = { bold: true, size: 9.5, color: { argb: "00000000" } };
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "CCECFF" },
          };
          cell.alignment = {
            horizontal: "center",
            vertical: "middle",
            wrapText: true,
          };
          cell.border = {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
          };
          // Optional: set column width
          //worksheet.getColumn(index + 1).width = Math.max(header.length + 5, 25);
          worksheet.getColumn(index + 1).width = 12;
        });
        headerRow.height = 50;

        // ✅ 3. Add filtered data rows starting from row 3
        const newDataArray = filterDataByKeys(headerAndKeyArray, empData);
        let rowIndex = 8;

        // newDataArray.forEach((item, index) => {
        console.log("newDataArray", newDataArray);
        newDataArray
          .sort(
            (a, b) =>
              financialMonthOrder.indexOf(a.mn) -
              financialMonthOrder.indexOf(b.mn),
          )
          .forEach((item, index) => {
            const row = worksheet.getRow(rowIndex++);
            Object.values(item).forEach((value, colIndex) => {
              const cell = row.getCell(colIndex + 1);
              if (formName === "employeeData") {
                if (colIndex === 0) {
                  cell.value = index + 1;
                } else {
                  cell.value = value || "";
                }
              } else {
                if (colIndex === 0) {
                  const dt = item.dc;
                  //const year = new Date(dt).getFullYear();
                  // const year = parseInt(financialYear.split("-")[0], 10);
                  // cell.value = `${value}-${year}`;
                  const [startYear, endYear] = financialYear.split("-");

                  const year = ["Jan", "Feb", "Mar"].includes(value)
                    ? endYear
                    : startYear;

                  cell.value = `${value}-${year}`;
                } else {
                  if (
                    colIndex + 1 === 21 ||
                    colIndex + 1 === 22 ||
                    colIndex + 1 === 23
                  )
                    return;
                  if (colIndex + 1 === 17) {
                    cell.value = item.gt - item.td;
                  } else {
                    cell.value = value || "";
                  }
                }
              }

              if (typeof value === "number" || !isNaN(value)) {
                if (cell.value === "") cell.value = "0.00";
                cell.alignment = { horizontal: "right", vertical: "middle" };
              } else {
                cell.alignment = { horizontal: "center", vertical: "middle" };
              }
              cell.font = { size: 9.5 };
            });
          });

        const ar_row = worksheet.getRow(rowIndex++);
        let cell = ar_row.getCell(1);
        cell.value = "ARREAR";
        cell.alignment = { horizontal: "center", vertical: "middle" };

        //Sum of Arrear
        const arrear = newDataArray.reduce((sum, val) => {
          const num = parseFloat(val.ar?.toString().trim()) || 0;
          return sum + num;
        }, 0);
        formatTotalRow(ar_row, arrear, 2, false);
        formatTotalRow(ar_row, arrear, 9, false);
        formatTotalRow(ar_row, arrear, 17, false);

        const bo_row = worksheet.getRow(rowIndex++);
        cell = bo_row.getCell(1);
        cell.value = "BONUS";
        cell.alignment = { horizontal: "center", vertical: "middle" };

        //Sum of Bonus
        const bonus = newDataArray.reduce((sum, val) => {
          const num = parseFloat(val.bo?.toString().trim()) || 0;
          return sum + num;
        }, 0);

        formatTotalRow(bo_row, bonus, 2, false);
        formatTotalRow(bo_row, bonus, 9, false);
        formatTotalRow(bo_row, bonus, 17, false);

        const da_row = worksheet.getRow(rowIndex++);
        cell = da_row.getCell(1);
        cell.value = "DA";
        cell.alignment = { horizontal: "center", vertical: "middle" };

        //Sum of DA
        const da = 0;
        // newDataArray.reduce((sum, val) => {
        //   const num = parseFloat(val.da?.toString().trim()) || 0;
        //   return sum + num;
        // }, 0);
        formatTotalRow(da_row, da, 2, false);
        formatTotalRow(da_row, da, 9, false);
        formatTotalRow(da_row, da, 17, false);

        // Add Total Row
        const row = worksheet.getRow(rowIndex++);
        formatTotalRow(row, "TOTAL", 1, true);

        //Total of Basic
        const totalBa = newDataArray.reduce((sum, val) => {
          const num = parseFloat(val.ba?.toString().trim()) || 0;
          return sum + num;
        }, 0);
        formatTotalRow(row, totalBa + arrear + bonus + da, 2, true);

        //Total of D.A.
        const totalDa = newDataArray.reduce((sum, val) => {
          const num = parseFloat(val.da?.toString().trim()) || 0;
          return sum + num;
        }, 0);
        formatTotalRow(row, totalDa, 3, true);

        //Total of Grade Pay
        const totalGp = newDataArray.reduce((sum, val) => {
          const num = parseFloat(val.gp?.toString().trim()) || 0;
          return sum + num;
        }, 0);
        formatTotalRow(row, totalGp, 4, true);

        //Total of H.R.A.
        const totalHr = newDataArray.reduce((sum, val) => {
          const num = parseFloat(val.hr?.toString().trim()) || 0;
          return sum + num;
        }, 0);
        formatTotalRow(row, totalHr, 5, true);

        //Total of C.C.A
        const totalCa = newDataArray.reduce((sum, val) => {
          const num = parseFloat(val.ca?.toString().trim()) || 0;
          return sum + num;
        }, 0);
        formatTotalRow(row, totalCa, 6, true);

        const totalOtherSalary = newDataArray.reduce((sum, val) => {
          const num = parseFloat(val.os?.toString().trim()) || 0;
          return sum + num;
        }, 0);
        formatTotalRow(row, totalOtherSalary, 7, true);

        //Total of Employer's Contribution Towards NPS
        const totalNps = newDataArray.reduce((sum, val) => {
          const num = parseFloat(val.nps?.toString().trim()) || 0;
          return sum + num;
        }, 0);
        formatTotalRow(row, totalNps, 8, true);

        //Total of Gross Total
        const totalGt = newDataArray.reduce((sum, val) => {
          const num = parseFloat(val.gt?.toString().trim()) || 0;
          return sum + num;
        }, 0);
        //formatTotalRow(row, totalGt + arrear + bonus + da, 9, true);
        formatTotalRow(row, totalGt + arrear + bonus + da, 9, true);

        //Total of G.P.F.
        const totalGpf = newDataArray.reduce((sum, val) => {
          const num = parseFloat(val.gpf?.toString().trim()) || 0;
          return sum + num;
        }, 0);
        formatTotalRow(row, totalGpf, 10, true);

        //Total of G.P.F. Advance Deduction
        const totalGpfAd = newDataArray.reduce((sum, val) => {
          const num = parseFloat(val.gpfad?.toString().trim()) || 0;
          return sum + num;
        }, 0);
        formatTotalRow(row, totalGpfAd, 11, true);

        //Total of G.I.S.
        const totalGis = newDataArray.reduce((sum, val) => {
          const num = parseFloat(val.gis?.toString().trim()) || 0;
          return sum + num;
        }, 0);
        formatTotalRow(row, totalGis, 12, true);

        //Total of HRA Deduction
        const totalHraDeduction = newDataArray.reduce((sum, val) => {
          const num = parseFloat(val.hrad?.toString().trim()) || 0;
          return sum + num;
        }, 0);
        formatTotalRow(row, totalHraDeduction, 13, true);

        //Total of Vehical Deduction
        const totalVclDeduction = newDataArray.reduce((sum, val) => {
          const num = parseFloat(val.vcld?.toString().trim()) || 0;
          return sum + num;
        }, 0);
        formatTotalRow(row, totalVclDeduction, 14, true);

        // //Total of Any Other Deduction U/S 80C
        // const total80c = newDataArray.reduce((sum, val) => {
        //   const num = parseFloat(val["80c"]?.toString().trim()) || 0;
        //   return sum + num;
        // }, 0);
        // formatTotalRow(row, total80c, 13, true);

        //Total of Income Tax
        const totalIt = newDataArray.reduce((sum, val) => {
          const num = parseFloat(val.it?.toString().trim()) || 0;
          return sum + num;
        }, 0);
        formatTotalRow(row, totalIt, 15, true);

        //Total of Total Deduction
        const totalTd = newDataArray.reduce((sum, val) => {
          const num = parseFloat(val.td?.toString().trim()) || 0;
          return sum + num;
        }, 0);
        formatTotalRow(row, totalTd, 16, true);

        //Total of Net Amount
        const totalNa = newDataArray.reduce((sum, val) => {
          const num =
            parseFloat(val.gt?.toString().trim() - val.td?.toString().trim()) ||
            0;
          return sum + num;
        }, 0);
        formatTotalRow(row, totalNa + arrear + bonus + da, 17, true);

        /**************************************/

        // Income Tax Memo Section Start Here

        /**************************************/
      } else if (formName === "incometaxMemo") {
        //Drop Down
        // const dropdownCell = worksheet.getCell("E1");
        // dropdownCell.value = "MALE"; // Default valuej
        // dropdownCell.dataValidation = {
        //   type: "list",
        //   allowBlank: true,
        //   formulae: ['"MALE,FEMALE,SENIOR CITIZEN,SUPER SENIOR CITIZEN"'],
        //   showErrorMessage: true,
        //   errorTitle: "Invalid Selection",
        //   error: "Please select a gender from the list.",
        // };
        // dropdownCell.font = { bold: true };

        worksheet.mergeCells(2, 1, 2, 5);
        const repportName = worksheet.getCell("A2");
        repportName.value = "INCOME TAX MEMO";
        repportName.font = { bold: true, size: 14 };
        repportName.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
        repportName.alignment = { horizontal: "center", vertical: "middle" };
        worksheet.getRow(2).height = 25;

        worksheet.mergeCells(3, 1, 3, 5);
        const repportFY = worksheet.getCell("A3");
        repportFY.value = `FOR THE F.Y. ${financialYear} A.Y. ${getAssessmentYear(
          financialYear,
        )}`;
        repportFY.font = { bold: true, size: 14 };
        repportFY.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
        repportFY.alignment = { horizontal: "center", vertical: "middle" };
        worksheet.getRow(3).height = 25;

        const EmployeeName = worksheet.getCell("A4");
        EmployeeName.value = "NAME OF THE EMPLOYEE";
        EmployeeName.font = { bold: true, size: 10 };
        EmployeeName.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FCD5B4" },
        };
        EmployeeName.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
        EmployeeName.alignment = { horizontal: "left", vertical: "middle" };
        worksheet.getRow(4).height = 25;

        worksheet.mergeCells(4, 2, 4, 3);
        const EmployeeNameValue = worksheet.getCell("B4");
        EmployeeNameValue.value = en;
        EmployeeNameValue.font = { bold: true, size: 10 };
        EmployeeNameValue.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FCD5B4" },
        };
        EmployeeNameValue.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
        EmployeeNameValue.alignment = {
          horizontal: "left",
          vertical: "middle",
        };
        worksheet.getRow(4).height = 25;

        const EmployeeDesignation = worksheet.getCell("D4");
        EmployeeDesignation.value = "DESIGNATION";
        EmployeeDesignation.font = { bold: true, size: 10 };
        EmployeeDesignation.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FCD5B4" },
        };
        EmployeeDesignation.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
        EmployeeDesignation.alignment = {
          horizontal: "left",
          vertical: "middle",
        };
        worksheet.getRow(4).height = 25;

        const EmployeeDesignationValue = worksheet.getCell("E4");
        EmployeeDesignationValue.value = de;
        EmployeeDesignationValue.font = { bold: true, size: 10 };
        EmployeeDesignationValue.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FCD5B4" },
        };
        EmployeeDesignationValue.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
        EmployeeDesignationValue.alignment = {
          horizontal: "left",
          vertical: "middle",
        };
        worksheet.getRow(4).height = 25;

        const OrgName = worksheet.getCell("A5");
        OrgName.value = "NAME OF OFFICE";
        OrgName.font = { bold: true, size: 10 };
        OrgName.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FCD5B4" },
        };
        OrgName.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
        OrgName.alignment = { horizontal: "left", vertical: "middle" };
        worksheet.getRow(5).height = 25;

        worksheet.mergeCells(5, 2, 5, 3);
        const OrgNameValue = worksheet.getCell("B5");
        OrgNameValue.value = clientInfo?.client?.cn;
        OrgNameValue.font = { bold: true, size: 10 };
        OrgNameValue.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FCD5B4" },
        };
        OrgNameValue.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
        OrgNameValue.alignment = { horizontal: "left", vertical: "middle" };
        worksheet.getRow(5).height = 25;

        const OrgDeductPan = worksheet.getCell("D5");
        OrgDeductPan.value = "PAN";
        OrgDeductPan.font = { bold: true, size: 10 };
        OrgDeductPan.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FCD5B4" },
        };
        OrgDeductPan.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
        OrgDeductPan.alignment = { horizontal: "left", vertical: "middle" };
        worksheet.getRow(5).height = 25;

        const OrgDeductPanValue = worksheet.getCell("E5");
        OrgDeductPanValue.value = pa;
        OrgDeductPanValue.font = { bold: true, size: 10 };
        OrgDeductPanValue.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FCD5B4" },
        };
        OrgDeductPanValue.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
        OrgDeductPanValue.alignment = {
          horizontal: "left",
          vertical: "middle",
        };
        worksheet.getRow(5).height = 25;

        const OrgAddress = worksheet.getCell("A6");
        OrgAddress.value = "ADDRESS";
        OrgAddress.font = { bold: true, size: 10 };
        OrgAddress.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FCD5B4" },
        };
        OrgAddress.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
        OrgAddress.alignment = { horizontal: "left", vertical: "middle" };
        worksheet.getRow(6).height = 25;
        worksheet.mergeCells(6, 2, 6, 5);
        const OrgAddressValue = worksheet.getCell("B6");
        OrgAddressValue.value = `${clientInfo?.client?.a1}${
          clientInfo?.client?.a2 ? ", " + clientInfo?.client?.a2 : ""
        }${clientInfo?.client?.ci ? ", " + clientInfo?.client?.ci : ""}${
          clientInfo?.client?.st ? ", " + clientInfo?.client?.st : ""
        }${clientInfo?.client?.pi ? " - " + clientInfo?.client?.pi : ""}`;
        OrgAddressValue.font = { bold: true, size: 10 };
        OrgAddressValue.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FCD5B4" },
        };
        OrgAddressValue.border = {
          top: { style: "thin" },
          bottom: { style: "thin" },
          left: { style: "thin" },
          right: { style: "thin" },
        };
        OrgAddressValue.alignment = { horizontal: "left", vertical: "middle" };
        worksheet.getRow(6).height = 25;

        // ✅ 2. Manually add header row (row 2)
        const headerRow = worksheet.getRow(7);
        // console.log("Header : ", headers);
        headers.forEach((header, index) => {
          // console.log("index = ", index + 1, " - header : ", header);
          const cell = headerRow.getCell(index + 1);
          cell.value = header;
          cell.font = { bold: true, size: 9.5, color: { argb: "00000000" } };
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "CCECFF" },
          };
          cell.alignment = {
            horizontal: "center",
            vertical: "middle",
            wrapText: true,
          };
          cell.border = {
            top: { style: "thin" },
            bottom: { style: "thin" },
            left: { style: "thin" },
            right: { style: "thin" },
          };
          // Optional: set column width
          //worksheet.getColumn(index + 1).width = Math.max(header.length + 5, 25);
          worksheet.getColumn(index + 1).width = 15;
        });
        headerRow.height = 25;

        const v_headers = extractKeyValues(reportIncometaxMemo, "label"); //Vertical Header
        const filteredData = filterDataByKeys(reportIncometaxMemo, empData);
        const firstRecord = filteredData[0] || {};

        const newTaxRegime = empData?.filter((e) => e.mn === "Mar");

        let rowIndex = 8;
        let surchargeRate = 0; // computed per-employee based on taxable income slab, used for dynamic SURCHARGE label + value

        reportIncometaxMemo
          .filter((item) => item.key !== "ec" && item.key !== "ed")
          .forEach((item, idx) => {
            const row = worksheet.getRow(rowIndex++);
            //Column 1 SNo
            let sno = row.getCell(1);
            sno.value = item?.sno;
            sno.font =
              item.bold === "true"
                ? { bold: true, size: "9.5" }
                : { size: "9.5" };
            sno.alignment = {
              horizontal: "center",
              vertical: "middle",
            };
            sno.border = {
              top: { style: "thin" },
              bottom: { style: "thin" },
              left: { style: "thin" },
              right: { style: "thin" },
            };

            let familyPension = empData.reduce((sum, val) => {
              const num = parseFloat(val["fpi"]?.toString().trim()) || 0;
              return sum + num;
            }, 0);

            let totFamilyPen = Math.min(
              (Number(familyPension) || 0) / 3,
              25000,
            );

            let isSnrCitizen = isSeniorCitizen(empData[0]?.ed, financialYear);

            console.log(
              "isSnrCitizen",
              isSnrCitizen,
              empData[0]?.ed,
              financialYear,
            );

            //const criticalIllnessAmount = Number(empData[0]?.["80ddb"]) || 0;
            let criticalIllnessAmount = empData.reduce((sum, val) => {
              const num = parseFloat(val["80ddb"]?.toString().trim()) || 0;
              return sum + num;
            }, 0);

            const max80DDBLimit = isSnrCitizen ? 100000 : 40000;

            const deduction80DDB = Math.min(
              criticalIllnessAmount,
              max80DDBLimit,
            );

            console.log(
              "deduction80DDB",
              criticalIllnessAmount,
              max80DDBLimit,
              deduction80DDB,
            );

            const disability = empData?.filter((e) => e.mn === "Mar");
            const disabilityType = disability[0]?.ds;

            let totGPF = empData.reduce((sum, val) => {
              const num = parseFloat(val["gpf"]?.toString().trim()) || 0;
              return sum + num;
            }, 0);
            let totGIS = empData.reduce((sum, val) => {
              const num = parseFloat(val["gis"]?.toString().trim()) || 0;
              return sum + num;
            }, 0);
            let totPPF = empData.reduce((sum, val) => {
              const num = parseFloat(val["ppf"]?.toString().trim()) || 0;
              return sum + num;
            }, 0);
            let totLIC = empData.reduce((sum, val) => {
              const num = parseFloat(val["lic"]?.toString().trim()) || 0;
              return sum + num;
            }, 0);
            let totLTF = empData.reduce((sum, val) => {
              const num = parseFloat(val["tf"]?.toString().trim()) || 0;
              return sum + num;
            }, 0);
            let totHP = empData.reduce((sum, val) => {
              const num = parseFloat(val["hp"]?.toString().trim()) || 0;
              return sum + num;
            }, 0);
            let totPI = empData.reduce((sum, val) => {
              const num = parseFloat(val["pi"]?.toString().trim()) || 0;
              return sum + num;
            }, 0);
            let totTI = empData.reduce((sum, val) => {
              const num = parseFloat(val["ti"]?.toString().trim()) || 0;
              return sum + num;
            }, 0);

            let totAnyOtherDeduc = empData.reduce((sum, val) => {
              const num = parseFloat(val["ad1"]?.toString().trim()) || 0;
              return sum + num;
            }, 0);

            let totNPS = empData.reduce((sum, val) => {
              const num = parseFloat(val["nps"]?.toString().trim()) || 0;
              return sum + num;
            }, 0);

            let tot80DS = empData.reduce((sum, val) => {
              const num = parseFloat(val["80ds"]?.toString().trim()) || 0;
              return sum + num;
            }, 0);

            if (tot80DS > 25000) {
              tot80DS = 25000;
            }

            let tot80DF = empData.reduce((sum, val) => {
              const num = parseFloat(val["80df"]?.toString().trim()) || 0;
              return sum + num;
            }, 0);

            if (tot80DF > 50000) {
              tot80DF = 50000;
            }

            let totTotalDeductionUS80C =
              totGPF +
              totGIS +
              totPPF +
              totLIC +
              totLTF +
              totHP +
              totPI +
              totTI +
              totNPS +
              totAnyOtherDeduc;

            //Column 2 Particulars
            let particulars = row.getCell(2);
            particulars.value =
              item?.key === "family_pen_inc"
                ? item?.label + ` (${familyPension})`
                : item?.key === "TOTAL_DEDUCTION_US80C"
                  ? item?.label + ` (${totTotalDeductionUS80C})`
                  : item?.key === "SURCHARGE"
                    ? `SURCHARGE @ ${surchargeRate}%`
                    : item?.label;
            particulars.font =
              item.bold === "true" ? { bold: true } : { size: "9.5" };
            particulars.alignment = {
              horizontal: "left",
              vertical: "middle",
            };
            particulars.border = {
              top: { style: "thin" },
              bottom: { style: "thin" },
              left: { style: "thin" },
              right: { style: "thin" },
            };
            particulars.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: item?.labelColor },
            };

            //Column 2 ParticularsII
            let particularsII = row.getCell(3);
            particularsII.value = item?.subLabel;
            particularsII.font =
              item.bold === "true" ? { bold: true } : { size: "9.5" };
            particularsII.alignment = {
              horizontal: "left",
              vertical: "middle",
            };
            particularsII.border = {
              top: { style: "thin" },
              bottom: { style: "thin" },
              left: { style: "thin" },
              right: { style: "thin" },
            };
            particularsII.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: item?.subLabelColor },
            };

            // Report Calculation
            let totBasic = empData.reduce((sum, val) => {
              const num = parseFloat(val["ba"]?.toString().trim()) || 0;
              return sum + num;
            }, 0);
            let totGPay = empData.reduce((sum, val) => {
              const num = parseFloat(val["gp"]?.toString().trim()) || 0;
              return sum + num;
            }, 0);
            let totDA = empData.reduce((sum, val) => {
              const num = parseFloat(val["da"]?.toString().trim()) || 0;
              return sum + num;
            }, 0);
            let totHRA = empData.reduce((sum, val) => {
              const num = parseFloat(val["hr"]?.toString().trim()) || 0;
              return sum + num;
            }, 0);
            let totCA = empData.reduce((sum, val) => {
              const num = parseFloat(val["ca"]?.toString().trim()) || 0;
              return sum + num;
            }, 0);
            let totTOI = empData.reduce((sum, val) => {
              const num = parseFloat(val["toi"]?.toString().trim()) || 0;
              return sum + num;
            }, 0);

            let totTOA = empData.reduce((sum, val) => {
              const num = parseFloat(val["toa"]?.toString().trim()) || 0;
              return sum + num;
            }, 0);

            let totTEMC = empData.reduce((sum, val) => {
              const num = parseFloat(val["emc"]?.toString().trim()) || 0;
              return sum + num;
            }, 0);

            let totTMED = empData.reduce((sum, val) => {
              const num = parseFloat(val["mr"]?.toString().trim()) || 0;
              return sum + num;
            }, 0);

            let totTRent = empData.reduce((sum, val) => {
              const num = parseFloat(val["rp"]?.toString().trim()) || 0;
              return sum + num;
            }, 0);

            let totSBInterest = empData.reduce((sum, val) => {
              const num = parseFloat(val["si"]?.toString().trim()) || 0;
              return sum + num;
            }, 0);

            let totFDRInterest = empData.reduce((sum, val) => {
              const num = parseFloat(val["fdi"]?.toString().trim()) || 0;
              return sum + num;
            }, 0);

            let totNSCInterest = empData.reduce((sum, val) => {
              const num = parseFloat(val["nsci"]?.toString().trim()) || 0;
              return sum + num;
            }, 0);

            console.log("totFamilyPen", familyPension, totFamilyPen);

            let totAnyOtherInc = empData.reduce((sum, val) => {
              const num = parseFloat(val["an1"]?.toString().trim()) || 0;
              return sum + num;
            }, 0);

            let tot80D = empData.reduce((sum, val) => {
              const num = parseFloat(val["80d"]?.toString().trim()) || 0;
              return sum + num;
            }, 0);
            let totTD = empData.reduce((sum, val) => {
              const num = parseFloat(val["td"]?.toString().trim()) || 0;
              return sum + num;
            }, 0);

            let tot80GEntered = empData.reduce((sum, val) => {
              const num = parseFloat(val["80g"]?.toString().trim()) || 0;
              return sum + num;
            }, 0);

            let tot80U = empData.reduce((sum, val) => {
              const num = parseFloat(val["80u"]?.toString().trim()) || 0;
              return sum + num;
            }, 0);

            if (disabilityType === "sd") {
              tot80U = 75000;
            } else if (disabilityType === "se") {
              tot80U = 125000;
            }

            // let tot80B = empData.reduce((sum, val) => {
            //   const num = parseFloat(val["80b"]?.toString().trim()) || 0;
            //   return sum + num;
            // }, 0);
            let tot80B = 0;

            if (clientInfo?.client?.igoc === 0) {
              tot80B = ((totBasic + totDA) * 10) / 100;
            } else {
              tot80B = ((totBasic + totDA) * 14) / 100;
            }

            console.log("total80B", tot80B);

            let totIT = empData.reduce((sum, val) => {
              const num = parseFloat(val["it"]?.toString().trim()) || 0;
              return sum + num;
            }, 0);
            let hseLoanInts = empData.reduce((sum, val) => {
              const num = parseFloat(val["ad2"]?.toString().trim()) || 0;
              return sum + num;
            }, 0);

            let tot80DD = empData.reduce((sum, val) => {
              const num = parseFloat(val["80dd"]?.toString().trim()) || 0;
              return sum + num;
            }, 0);

            // Flat disability deduction, irrespective of actual expenditure incurred:
            // Standard Disability (40% to less than 80%)  => Rs. 75,000
            // Severe Disability (80% or more)             => Rs. 1,25,000
            // "ds" (disability) is captured only on the March record, same as
            // other annual-only fields (nt, 80dd, 80ddb, 80e, etc.)

            if (tot80DD > 0) {
              if (disabilityType === "sd") {
                tot80DD = 75000;
              } else if (disabilityType === "se") {
                tot80DD = 125000;
              }
            }
            console.log(
              "disabilityType11",
              disabilityType,
              "tot80DD11",
              tot80DD,
            );
            let tot80DDB = empData.reduce((sum, val) => {
              const num = parseFloat(val["80ddb"]?.toString().trim()) || 0;
              return sum + num;
            }, 0);

            let tot80E = empData.reduce((sum, val) => {
              const num = parseFloat(val["80e"]?.toString().trim()) || 0;
              return sum + num;
            }, 0);

            let tot80CCD = empData.reduce((sum, val) => {
              const num = parseFloat(val["80b"]?.toString().trim()) || 0;
              return sum + num;
            }, 0);

            // let tot80TTA = empData.reduce((sum, val) => {
            //   const num = parseFloat(val["80tta"]?.toString().trim()) || 0;
            //   return sum + num;
            // }, 0);

            let tot80TTA =
              isSnrCitizen === false ? Math.min(totSBInterest, 10000) : 0;

            // let tot80TTB = empData.reduce((sum, val) => {
            //   const num = parseFloat(val["80ttb"]?.toString().trim()) || 0;
            //   return sum + num;
            // }, 0);

            const eligibleInterest =
              Number(totSBInterest || 0) + Number(totFDRInterest || 0);

            let tot80TTB =
              isSnrCitizen === false ? Math.min(eligibleInterest, 50000) : 0;

            let tot80CCD1B = empData.reduce((sum, val) => {
              const num = parseFloat(val["80b"]?.toString().trim()) || 0;
              return sum + num;
            }, 0);

            //tot80CCD1B = tot80CCD1B > 50000 ? 50000 : tot80CCD1B;

            let tot80CCH2 = empData.reduce((sum, val) => {
              const num = parseFloat(val["80cch2"]?.toString().trim()) || 0;
              return sum + num;
            }, 0);

            let empCity = empData[0]?.["ec"]?.toString().trim() || "";

            // Gross Salary
            let grossSalary =
              totBasic +
              totGPay +
              totDA +
              totHRA +
              totCA +
              totTOI +
              totTOA +
              totTEMC +
              totTMED +
              totTRent;

            let totLessStandardDeduction16ia =
              newTaxRegime[0].nt === 1
                ? grossSalary < 75000
                  ? grossSalary
                  : 75000
                : grossSalary < 50000
                  ? grossSalary
                  : 50000;

            const metroCities = ["DELHI", "MUMBAI", "KOLKATA", "CHENNAI"];
            const isMetroCity = metroCities.includes(
              (empCity || "").trim().toUpperCase(),
            );

            // HRA Calculation
            let totSalary = totBasic + totDA;

            let salaryPercentage = isMetroCity
              ? (totSalary * 50) / 100
              : (totSalary * 40) / 100;

            let totHouseLoanInterest =
              hseLoanInts > 200000 ? 200000 : hseLoanInts;

            // Actual HRA Received
            let actualHRA = totHRA;

            // Total Rent Paid
            let totRentPaid = Number(worksheet.getCell("A1").value) || 0;

            // Rent Paid - 10% of Salary
            let salary10Per = (totSalary * 10) / 100;
            let rentMinus10PerSalary = Math.max(0, totRentPaid - salary10Per);

            let hraExempt = Math.min(
              actualHRA ?? 0,
              rentMinus10PerSalary ?? 0,
              salaryPercentage ?? 0,
            );

            let totNetSalary =
              Number(grossSalary) -
              Math.abs(Number(totLessStandardDeduction16ia)) -
              Math.abs(Number(hraExempt)) -
              Math.abs(Number(totHouseLoanInterest));

            let totTotalIncom =
              totNetSalary +
              (totSBInterest +
                totFDRInterest +
                totNSCInterest +
                totFamilyPen +
                totAnyOtherInc);

            let tot80GDeduction =
              totTotalIncom -
              (tot80DS +
                tot80DF +
                tot80DD +
                tot80DDB +
                tot80E +
                tot80TTA +
                tot80TTB +
                tot80U +
                tot80B +
                tot80CCD1B +
                tot80CCH2);
            tot80GDeduction = (tot80GDeduction * 10) / 100;

            // "80gTyp" from March record: 50 = 50% deduction, 100 = 100% deduction (default 50)
            const gTyp = Number(newTaxRegime[0]?.["80gTyp"]) || 50;
            let tot80G = (Math.min(tot80GDeduction, tot80GEntered) * gTyp) / 100;

            let totTotalDeduction =
              tot80DS +
              tot80DF +
              tot80DD +
              tot80DDB +
              tot80E +
              tot80G +
              tot80TTA +
              tot80TTB +
              tot80U +
              tot80B +
              tot80CCD1B +
              tot80CCH2;

            // //HRA Calculation
            // let totSalary = totBasic + totDA;
            // //AN AMOUNT EQUAL TO 40 % OF SALARY
            // let salary40Per = (totSalary * 40) / 100;
            // // A : WHICH EVER IS LESS
            // let aSection = salary40Per < totHRA ? salary40Per : totHRA;
            // // TOAL RENT PAID
            // let totRentPaid = worksheet.getCell("A1").values || 0;
            // let salary10Per = (totSalary * 10) / 100;
            // // B : (WHICHEVER IS LOWER IN A AND B)
            // let bNetAmount = totRentPaid - salary10Per;
            // let hraExempt = aSection < bNetAmount ? aSection : bNetAmount;

            // Metro city check

            // 50% for Metro, 40% for Non-Metro

            // HRA Exemption = Least of:
            // 1. Actual HRA received
            // 2. Rent paid - 10% of salary
            // 3. 50%/40% of salary

            console.log(":ssss", hraExempt);

            let totComputationOfTax = 0;
            let totTaxPayble = 0;
            let totLessRebateUS87A = 0;

            const ttd80C = Math.min(Number(totTotalDeductionUS80C), 150000);

            let taxableIncome =
              Number(totTotalIncom) - (ttd80C + Number(totTotalDeduction));

            // Surcharge is levied on tax amount (not income); rate determined by taxable income slab
            // New Tax Regime: max surcharge capped at 25% | Old Tax Regime: up to 37% for >5Cr
            if (taxableIncome <= 5000000) {
              surchargeRate = 0;       // up to ₹50 lakh: Nil
            } else if (taxableIncome <= 10000000) {
              surchargeRate = 10;      // ₹50L – ₹1Cr: 10%
            } else if (taxableIncome <= 20000000) {
              surchargeRate = 15;      // ₹1Cr – ₹2Cr: 15%
            } else if (taxableIncome <= 50000000) {
              surchargeRate = 25;      // ₹2Cr – ₹5Cr: 25%
            } else {
              surchargeRate = newTaxRegime[0].nt === 1 ? 25 : 37; // >₹5Cr: 25% (new) / 37% (old)
            }
            console.log("[SURCHARGE DEBUG] taxableIncome:", taxableIncome, "| surchargeRate:", surchargeRate, "| totComputationOfTax:", totComputationOfTax, "| totTotalIncom:", totTotalIncom, "| totTotalDeduction:", totTotalDeduction);

            let totReliefUS89 = 0;

            let amount2 = row.getCell(5);

            if (newTaxRegime[0].nt === 1) {
              totComputationOfTax = calculateTaxFromJSON(
                taxableIncome,
                financialYear,
              );
            } else {
              const ageCategory = getAgeCategoryFromDOB(newTaxRegime[0].ed);

              totComputationOfTax = calculateOldRegimeTax(
                taxableIncome,
                financialYear,
                newTaxRegime[0].eg || "Male",
                ageCategory,
              );
            }

            console.log("Total Computation of Tax:", totComputationOfTax);

            let totNetTaxPayble =
              totComputationOfTax <= totLessRebateUS87A
                ? 0
                : totComputationOfTax - totLessRebateUS87A;

            // Surcharge amount (on base tax, before rebate)
            const surchargeAmount = Math.round((totComputationOfTax * surchargeRate) / 100);
            // Cess = 4% on (Net Tax after rebate + Surcharge)
            // If rebate wipes out all tax, totNetTaxPayble = 0 → cess = 0 naturally
            let totHealthEducationCess = Math.round(
              ((totNetTaxPayble + surchargeAmount) * 4) / 100,
              0,
            );

            //Column 2 Amount1
            let amount1 = row.getCell(4);
            // amount1.numFmt = '_(* #,##0_);_(* (#,##0);_(* ""??_);_(@_)';
            amount1.value =
              reportIncometaxMemo[idx]?.key === "gt"
                ? grossSalary
                : reportIncometaxMemo[idx]?.key ===
                    "LESS_STANDARD_DEDUCTION_US_16ia"
                  ? totLessStandardDeduction16ia
                  : reportIncometaxMemo[idx]?.key === "INCOME_FROM_SALARY"
                    ? Number(grossSalary - totLessStandardDeduction16ia)
                    : reportIncometaxMemo[idx]?.key === "LESS_HRA"
                      ? Number(hraExempt)
                      : reportIncometaxMemo[idx]?.key === "family_pen_inc"
                        ? Number(totFamilyPen)
                        : reportIncometaxMemo[idx]?.key === "LESS_HLI"
                          ? totHouseLoanInterest
                          : reportIncometaxMemo[idx]?.key === "U/S_80DD"
                            ? tot80DD
                            : reportIncometaxMemo[idx]?.key === "U/S_80DDB"
                              ? deduction80DDB
                              : reportIncometaxMemo[idx]?.key === "U/S_80G"
                                ? tot80G
                                : reportIncometaxMemo[idx]?.key === "U/S_80TTA"
                                  ? tot80TTA
                                  : reportIncometaxMemo[idx]?.key === "U/S_80U"
                                    ? tot80U
                                    : reportIncometaxMemo[idx]?.key ===
                                        "U/S_80TTB"
                                      ? tot80TTB
                                      : reportIncometaxMemo[idx]?.key ===
                                          "U/S_80CCD(2)"
                                        ? tot80B
                                        : reportIncometaxMemo[idx]?.key ===
                                            "U/S_80CCD(1B)"
                                          ? tot80CCD1B
                                          : reportIncometaxMemo[idx]?.key ===
                                              "TOTAL_OF_COLUMN_NO_3"
                                            ? hraExempt - totHouseLoanInterest //totHouseLoanInterest is N/A
                                            : reportIncometaxMemo[idx]?.key ===
                                                "TOTAL_OF_COLUMN_NO_6"
                                              ? totSBInterest +
                                                totFDRInterest +
                                                totNSCInterest +
                                                totFamilyPen +
                                                totAnyOtherInc
                                              : reportIncometaxMemo[idx]
                                                    ?.key ===
                                                  "TOTAL_DEDUCTION_US80C"
                                                ? totTotalDeductionUS80C <
                                                  150000
                                                  ? totTotalDeductionUS80C
                                                  : 150000
                                                : reportIncometaxMemo[idx]
                                                      ?.key === "med_for_self"
                                                  ? tot80DS
                                                  : reportIncometaxMemo[idx]
                                                        ?.key ===
                                                      "med_for_family"
                                                    ? tot80DF
                                                    : reportIncometaxMemo[idx]
                                                          ?.key ===
                                                        "TOTAL_DEDUCTION"
                                                      ? (totTotalDeductionUS80C <
                                                        150000
                                                          ? totTotalDeductionUS80C
                                                          : 150000) +
                                                        totTotalDeduction
                                                      : reportIncometaxMemo[idx]
                                                            ?.key ===
                                                          "SURCHARGE"
                                                        ? surchargeAmount
                                                        : reportIncometaxMemo[
                                                              idx
                                                            ]?.key ===
                                                            "COMPUTATION_OF_TAX"
                                                          ? totComputationOfTax // totComputationOfTax = Need Calculation
                                                          : reportIncometaxMemo[
                                                                idx
                                                              ]?.key ===
                                                              "TAX_PAYABLE"
                                                            ? totComputationOfTax // totComputationOfTax = Need Calculation
                                                            : reportIncometaxMemo[
                                                                  idx
                                                                ]?.key ===
                                                                "LESS_REBATE_US_87A"
                                                              ? totLessRebateUS87A
                                                              : reportIncometaxMemo[
                                                                    idx
                                                                  ]?.key ===
                                                                  "NET_TAX_PAYABLE"
                                                                ? totNetTaxPayble
                                                                : reportIncometaxMemo[
                                                                      idx
                                                                    ]?.key ===
                                                                    "HEALTH_AND_EDUCATION_CESS"
                                                                  ? totHealthEducationCess
                                                                  : reportIncometaxMemo[
                                                                        idx
                                                                      ]?.key ===
                                                                      "TOTAL_TAX_PAYABL"
                                                                    ? totNetTaxPayble +
                                                                      totHealthEducationCess
                                                                    : empData.reduce(
                                                                        (
                                                                          sum,
                                                                          val,
                                                                        ) => {
                                                                          const num =
                                                                            parseFloat(
                                                                              val[
                                                                                reportIncometaxMemo[
                                                                                  idx
                                                                                ]
                                                                                  ?.key
                                                                              ]
                                                                                ?.toString()
                                                                                .trim(),
                                                                            ) ||
                                                                            0;
                                                                          return (
                                                                            sum +
                                                                            num
                                                                          );
                                                                        },
                                                                        0,
                                                                      );

            amount1.numFmt =
              amount1.value >= 0
                ? `#,##0.00`
                : `_(* #,##0_);_(* (#,##0);_(* ""??_);_(@_)`;

            amount1.font =
              item?.bold === "true"
                ? { bold: true, size: "9.5" }
                : { size: "9.5" };

            amount1.alignment = {
              horizontal: "right",
              vertical: "middle",
            };
            amount1.border = {
              top: { style: "thin" },
              bottom: { style: "thin" },
              left: { style: "thin" },
              right: { style: "thin" },
            };
            amount1.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: item?.color },
            };

            amount2.value =
              reportIncometaxMemo[idx]?.key === "INCOME_FROM_SALARY"
                ? grossSalary - totLessStandardDeduction16ia
                : reportIncometaxMemo[idx]?.key === "TOTAL_OF_COLUMN_NO_3"
                  ? hraExempt - totHouseLoanInterest //totHouseLoanInterest is N/A
                  : reportIncometaxMemo[idx]?.key === "TOTAL_OF_COLUMN_NO_6"
                    ? totSBInterest +
                      totFDRInterest +
                      totNSCInterest +
                      totFamilyPen +
                      totAnyOtherInc
                    : reportIncometaxMemo[idx]?.key === "NET_SALARY"
                      ? totNetSalary
                      : reportIncometaxMemo[idx]?.key === "TOTAL_INCOME"
                        ? totTotalIncom
                        : reportIncometaxMemo[idx]?.key === "TOTAL_DEDUCTION"
                          ? (totTotalDeductionUS80C < 150000
                              ? totTotalDeductionUS80C
                              : 150000) + totTotalDeduction
                          : reportIncometaxMemo[idx]?.key === "TAXABLE_INCOME"
                            ? taxableIncome
                            : reportIncometaxMemo[idx]?.key ===
                                "TOTAL_TAX_PAYABLE"
                              ? totNetTaxPayble + totHealthEducationCess
                              : reportIncometaxMemo[idx]?.key ===
                                  "TOTAL_TAX_PAYABLE_AFTER_RELIEF_OF_US_89"
                                ? totNetTaxPayble +
                                  totHealthEducationCess -
                                  totReliefUS89
                                : reportIncometaxMemo[idx]?.key ===
                                    "TAX_DEDUCTED_AT_SOURCE"
                                  ? totIT
                                  : reportIncometaxMemo[idx]?.key ===
                                      "NET_TAX_PAYABLE_REFUNDABLE"
                                    ? totNetTaxPayble +
                                      totHealthEducationCess -
                                      totReliefUS89 -
                                      totIT
                                    : 0;

            amount2.numFmt =
              amount2.value > 0
                ? `#,##0.00`
                : `_(* #,##0_);_(* (#,##0);_(* ""??_);_(@_)`;

            amount2.font =
              item?.bold === "true" ? { bold: true } : { size: "9.5" };
            amount2.alignment = {
              horizontal: "right",
              vertical: "middle",
            };
            amount2.border = {
              top: { style: "thin" },
              bottom: { style: "thin" },
              left: { style: "thin" },
              right: { style: "thin" },
            };
            amount2.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: item?.amtColor },
            };
            // row.alignment = { horizontal: "left", vertical: "middle" };
          });

        // Format Columns
        reportIncometaxMemo.forEach((v_header, i) => {
          worksheet.getColumn(1).width = Math.max(25, 5);
          worksheet.getColumn(2).width = Math.max(
            v_header?.label?.length + 5,
            70,
          );
          worksheet.getColumn(3).width = Math.max(0, 0);
          worksheet.getColumn(4).width = Math.max(15, 5);
          worksheet.getColumn(5).width = Math.max(15, 5);
        });
      }
      indexForEach++;
    });

    // ✅ 4. Save to file
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(blob, `${fileName}.xlsx`);
  };

  return (
    <>
      <Button
        variant="success"
        onClick={exportToExcel}
        disabled={data.length <= 0}
      >
        Generate Report
      </Button>
    </>
  );
};
export default ExportToExcelDeductee24Q;
